import { EventActionType } from './event-action-type';
import { EventEntry } from '../../state';

export interface LoadEventAction {
  eventKey: string;
  event?: Partial<EventEntry['event']>;
  type: EventActionType.LoadEvent;
}

export const loadEvent = (
  eventKey: string,
  event?: Partial<
    Omit<EventEntry['event'], 'key'> & {
      occurrences: Pick<
        EventEntry['event']['occurrences'][0],
        'startsAt' | 'duration'
      >;
    }
  >,
): LoadEventAction => ({
  eventKey,
  event,
  type: EventActionType.LoadEvent,
});
